import React, { PropTypes } from 'react';
import Dropzone from 'react-dropzone';
import update from 'react/lib/update';
import { disableOpenFileInBrowser } from '../../businessLogic/util';
import ReactTooltip from 'react-tooltip';
import SparkMD5 from 'spark-md5';
import { prettyAlert } from '../Common/Dialog';
// @TODO: tirar o disabled
// @TODO: remover o validatorBT
// @TODO: remover props inuteis
// @TODO: mudar endereco do ftp

export default class DropzoneWrapper extends React.Component {	

	constructor(props) {
		super(props);
		this.state = {
			className: 'dropzone',
			disabled: false,
			errorMessage: false,
			loadingBox: false,
			fileLoading: 'none',
			filesQTDE: '0',
			fileNum: '0'
		};
		disableOpenFileInBrowser();
	}
	
	componentDidMount() { 
		this._ismounted = true;
		this.validatorBt(this.props.files);
		this.processImportedFiles();
	}
	componentWillUnmount() {
		this._ismounted = false;
	}

	renderFetching() {
		if ( this.state.loadingBox ) {
			return ( <div className="alert alert-warning container_sms" style={{marginTop: '10px'}}>
				<i className="fas fa-circle-notch fa-spin" />
				<strong>    Validando arquivos! </strong>
				{this.state.filesQTDE !== '0'
					? `${this.state.fileNum}/${this.state.filesQTDE} arquivos validados.`
					: null}
				<br></br>
					Por favor aguarde.
			</div>);
		}
	}

	async onDrop(files) {
		const newFiles = [];
		const newFilesFiltered = [];
		let counter = 1;
		for ( let f of files) {
			let b = await fetch(f.preview).then(r => r.blob());
			if (b.size > 400 * 1024 * 1024) {
				prettyAlert(`${f.name} grande demais!`, `O limite máximo é de 400 MB por arquivo.`);
				continue;
			}
			//furious	
			this.setState({loadingBox: true, fileLoading: f.name, filesQTDE: files.length,
				fileNum: counter});
			//await only blocks code execution inside async func
			await this.readFileAsync(f).then((result) => {}, (error) => { console.error("It failed with " + error); });
			
			// Check for repetitions
			if (typeof f.DocumentID !== "undefined") {
				this.props.salvarEnabledFunction(false);
			}
			newFilesFiltered.push(f);
			counter += 1;
		}
		this.setState({loadingBox: false});

		newFilesFiltered.map((newFile) => {
			const equal = this.props.files.filter((f) => f.name === newFile.name && f.lastModified === newFile.lastModified);
			if ( equal.length === 0 ) newFiles.push(newFile);
		});

		// Set FormData
		this.props.onDrop(this.props.files.concat(newFiles));
		this.validatorBt(this.props.files);
		this.showErrorMessage(this.props.files);
		
	}

	async readFileAsync(file) {
		return new Promise((resolve, reject) => {
			let a = new FileReader();
			// let filesize = file.size;
			let filehash = 0;
			a.readAsArrayBuffer(file);
			let fileReturns = {};
			a.onload = () => {
				filehash = SparkMD5.ArrayBuffer.hash(a.result);

				fileReturns = this.props.checkExistance(filehash);
				fileReturns.then( function(e) {
					file.hash = filehash;
					file.ExisteNoFTP = e.tem_no_bd;
					if (e.tem_em_documento_no_bd) {
						file.DocumentID = e.documents_in_bd[0];
					}
				});
				resolve(fileReturns);
			};
		});
	}

	async processImportedFiles() {
		const importedFromFTP = this.props.fileIDs;		
		if (importedFromFTP.length) {
			this.setState({ loadingBox: true });
			
			const filesToBeFetched = [];	
			
			importedFromFTP.map(hash => 
				filesToBeFetched.push(this.props.checkExistance(hash))
			);	
			Promise.all(filesToBeFetched).then((values) => {
				values.map(details => {
					details.ExisteNoFTP = details.tem_no_bd;
					details.importedFromFTP = true;
					this.props.files.push(details);
				});
				
				this.setState({ loadingBox: false });
			});
		}
	}

	async checkExistance(fileblob) {
		
		let a = new FileReader();
		// let filesize = fileblob.size;
		let filehash = 0;
		let fileReturns = {};
		a.readAsArrayBuffer(fileblob);

		a.onload = function () {
			filehash = SparkMD5.ArrayBuffer.hash(a.result);

		};
		a.onloadend = () => {
			fileReturns = this.props.checkExistance(filehash);
		};
		return fileReturns[0];
	}
	// TODO: demorando um pouco pra carregar os arquivos
	// the function above checks if, after remove a document
	// there steel an element that is registered in db 
	// TODO: Parece ter um typo no nome dessa funcao. 
	// Melhor corrigir para fazer mais sentido
	steelDBContainedFile(newFiles) {
		let cont = false;
		newFiles.filter((e) => {
			if (typeof e.DocumentID !== "undefined") {
				cont = true;
			}
		});
		return cont;
	}

	removeFile(index) {
		const newFiles = update(this.props.files, { $splice: [[index, 1]] });
		this.props.onDrop(newFiles);

		if (!this.steelDBContainedFile(newFiles) ) {
			this.props.salvarEnabledFunction(true);
			// this.setState({disabled: false});
			this.validatorBt(newFiles);
			this.showErrorMessage(newFiles);
		}
		this.validatorBt(newFiles);	
		this.showErrorMessage(newFiles);

	}

	getSavedFiles() {
		return this.props.savedFiles.length === 0 
			? null
			: (
			<div>
				{this.props.savedFiles.map((f, i) =>
					<div key={i} className="file-row">
						<div className="col-md-10">
							<b><a className="pointer"
								onClick={() => this.props.downloadFile(f)}>{f.name}</a></b>
						</div>
						<div className="col-md-2">
							<span className="pull-right" style={{paddingRight: "10px"}}>
								{this.renderEditarLink(f)}					
								<i 
									className="fa fa-trash pointer" 
									data-tip="Deletar"
									onClick={() => this.props.deleteFile(f.hash, f.name)} 
								/>									
							</span>
						</div>
						<ReactTooltip />
					</div>
				)}
				{this.renderDownloadAsZipButton()}
				<hr />
			</div>
			);
	}
	
	// TODO : handle link exists in more than one file, group it 
	handleLink(id) {							
		this.props.router.push.bind(this, `/admin/documents/view/${id}`);
	}
	
	renderErrorMessagerdDB() {
		if (this.state.errorMessage) {
			return (
				<div className="alert alert-danger container_dbexist">
					<strong>Atenção!</strong> O arquivo em vermelho já está presente na base.
				</div>
			);
		}
	}

	spanExisteNoFTP(f) {
		if (f.ExisteNoFTP) {
			const datatip = "importedFromFTP" in f && f.importedFromFTP 
				? "Arquivo importado do FTP" 
				: "Arquivo encontrado no FTP";
			
			return (
				<a className="pointer" 
					data-tip={datatip}
					onClick={() => this.props.downloadExported(f.hash)}>
					{f.name}
				</a>
			);
		}
		
	}

	spanFileInDB(f) {
		let retVal;
		if (typeof f.DocumentID !== "undefined" ) {
			retVal = (
				<span >
					<a className="pointer textSpanDocCad" 
					data-tip="Arquivo encontrado em documento cadastrado"
					target="_blank" href={f.preview} style={{color: '#F23827'}}>
					{f.name}
					</a>
				</span>
			);
		}
		return retVal;
	}
	
	spanNewFile(f) {
		if (typeof f.DocumentID === "undefined" && !f.ExisteNoFTP) {
			return (
				<a 
					className="pointer" 
					data-tip="Novo arquivo"
					target="_blank" 
					href={f.preview}>
						{f.name}
				</a>
			);
		}
		
	}

	renderFtpInfoLink(f) {
		if (f.ExisteNoFTP && !("importedFromFTP" in f)) {
			return (	
				<a>
					<i 
						className="fas fa-info-circle"
						data-tip="Esse arquivo foi encontrado no FTP e será cadastrado com o nome já existente no sistema." 
					/>
				</a>
			);
		}
	}

	renderEditarLink(f) {
		if (typeof f.DocumentID !== "undefined" ) {
			return (	
				<a href={`/admin/documents/view/${f.DocumentID}`} target="_blank">
					<i 
						className="fa fa-share"
						data-tip="Ir para documento cadastrado" 
					/>
				</a>
			);
		}
	}

	renderTrashLink(i) {
		return (
			<a onClick={this.removeFile.bind(this, i)}>
				<i 
					className="far fa-trash-alt pointer" 
					data-tip="Remover"
				/>		
			</a>
		);
	}

	getNewFiles() {
		return this.props.files.map((f, i) =>							
			<div key={i} className="file-row">
				<div className="filename">
					{this.spanExisteNoFTP(f)}
					{this.spanFileInDB(f)}
					{this.spanNewFile(f)}
				</div>
				{this.renderEditarLink(f)}				
				{this.renderFtpInfoLink(f)}				
				{this.renderTrashLink(i)}	
				
				<ReactTooltip />
			</div>
		);
	}
	// TODO: allowNextPge and renderNextPageButton might be redundant
	// deprecated
	renderNextPageButton() {
		if (this.state.disabled) {
			return (<button type="button" className="btn btn-primary" 
			style={{right: '15', position: 'absolute', bottom: '0'}} disabled >Próxima Página</button>);
		} else {
			return (<button type="button" className="btn btn-primary" 
			style={{right: '15', position: 'absolute', bottom: '0'}} onClick={() => 
				this.props.allowNextPageFunction(true)
			}>Próxima Página</button>);
		}
	}

	showErrorMessage(nfiles) {
		if ( nfiles.length === 0) {
			this.setState({errorMessage: false});
			return;
		}
		let loopCheck = false;
		nfiles.some( (f) => {
			if (typeof f.DocumentID !== "undefined" ) {
				loopCheck = false;
				return true;
			} else {
				loopCheck = true;
				return false;
			}
		});
		if (loopCheck) {
			this.setState({errorMessage: false});
		} else {
			this.setState({errorMessage: true});
		}

	}
	// validatorBt: verifies if the nextpage button can be enabled or not 
	validatorBt(nfiles) {
		if ( nfiles.length === 0) {
			this.setState({disabled: false});
		}

		let loopCheck = false;
		nfiles.some( (f) => {
			if (typeof f.DocumentID !== "undefined" ) {
				loopCheck = false;
				return true;
			} else {
				loopCheck = true;
				return false;
			}
		});
		if (loopCheck) {
			this.setState({disabled: false});
		} else {
			this.setState({disabled: true});
		}
	}
	renderValidandoMessage() {
		return (<div className="boxText">
			<strong>Aguarde até os arquivos serem validados.</strong>
			<br></br>
			{this.state.fileLoading !== "none" ? <span>
				<strong>Validando: 
				{" " + this.state.fileLoading} </strong>

			</span> : null}
		</div>);
	}

	renderDownloadAsZipButton() {
		if (this.props.isEdit === false) return "";
		const isProcessing = this.props.isProcessingZip; 

		return (
			<div className="btndzip">
				<button className="btn btn-default btn-downloadaszip"
				onClick={() => this.props.downloadFilesAsZip(this.props.docId)} 
				disabled={isProcessing}>
					{isProcessing 
					? <div><i className="fas fa-circle-notch fa-spin fa-fw" /> Baixando...</div> 
					: "Baixar .zip"}
				</button>
			</div>
		);
	}
// TODO limit of files uploaded, tag html
	render () {	
		return (
			<div className="row">
				<div className="col-md-6 " style={{marginLeft: '0px'}}>
					<div 
						onMouseOver={() => this.setState({className: 'dropzone dropzone-active'})}						
						onMouseOut={() => this.setState({className: 'dropzone'})}>
						<Dropzone 						
							onDrop={this.onDrop.bind(this)} 
							className={this.state.loadingBox ? "dropzone-disabled": this.state.className}
							activeClassName='dropzone dropzone-active' 
							multiple
						>
							<div className="dropzone-text">
								{this.state.loadingBox? this.renderValidandoMessage()
								: "Arraste e solte arquivos aqui, ou clique para fazer o upload"}
								
							</div>
						</Dropzone>						
					</div>
				</div>
				<div className="col-md-6 boxesWrapper">
					<div className="container_list">
						{this.getSavedFiles()}
						{this.getNewFiles()}
						{/* {this.renderDownloadAsZipButton()} */}
					</div>
						{this.renderErrorMessagerdDB()}
						{this.renderFetching()}

					<div>			

					</div>				
				</div>
			</div>						
		);
	}
}

DropzoneWrapper.propTypes = {
	files: PropTypes.array.isRequired,
	savedFiles: PropTypes.array.isRequired,
	fileIDs: PropTypes.array.isRequired,
	isEdit: PropTypes.bool.isRequired,
	docId: PropTypes.number,
	onDrop: PropTypes.func.isRequired,
	downloadExported: PropTypes.func.isRequired,
	router: PropTypes.object.isRequired,	
	downloadFile: PropTypes.func.isRequired,
	downloadFilesAsZip: PropTypes.func.isRequired,
	deleteFile: PropTypes.func.isRequired,
	checkExistance: PropTypes.func.isRequired,
	salvarEnabledFunction: PropTypes.func.isRequired,
	allowNextPageFunction: PropTypes.func,
	isProcessingZip: PropTypes.bool.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/DropzoneWrapper.js